var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndegeneNLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.995,
    height: 64,
    viewBox: "0 0 63.995 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,47.025V18.847h14.42V47.025Z",
    transform: "translate(-0.001 16.967)",
    fill: "#034ea2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M26.023,7.618V57.2H40.447V7.618Z",
    transform: "translate(23.547 6.805)",
    fill: "#ed0677"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.023,14.463H40.447V.047H26.023Z",
    transform: "translate(23.547 -0.047)",
    fill: "#034ea2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M27.94,11.282H0V25.7H27.94Z",
    transform: "translate(-0.001 10.12)",
    fill: "#00c0f3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M49.57.05H0V14.466H49.571Z",
    transform: "translate(-0.001 -0.044)",
    fill: "#00c0f3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.664,18.855v28.17H29.09V18.847Z",
    transform: "translate(13.268 16.967)",
    fill: "#ed0677"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M14.664,25.7H29.09V11.282H14.664Z",
    transform: "translate(13.268 10.12)",
    fill: "#034ea2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndegeneNLogo);
export default __webpack_public_path__ + "static/media/Indegene-N-logo.ed58fb7d8dd39e5f28ad83d914f6a105.svg";
export { ForwardRef as ReactComponent };